<section *ngIf="open && panel.canUseAiChat" class="tt-ai-chat-panel" aria-label="AI chat panel">
    <div
        *ngIf="!mobile"
        class="tt-ai-chat-panel__resize-handle"
        role="separator"
        aria-label="Resize AI chat panel"
        aria-orientation="vertical"
        tabindex="0"
        [attr.aria-valuemin]="minimumWidth"
        [attr.aria-valuemax]="currentMaximumWidth"
        [attr.aria-valuenow]="width"
        (pointerdown)="onResizeStart($event)"
        (pointermove)="onResizeMove($event)"
        (pointerup)="onResizeEnd($event)"
        (pointercancel)="onResizeEnd($event)"
        (keydown)="onResizeKeydown($event)"
    ></div>

    <tt-ai-chat></tt-ai-chat>
</section>
